import { useState, useRef, useEffect  } from 'react';
import { motion, useAnimation } from 'framer-motion';

//MUI Icons
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

//MUI
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//Our Imports
import oneBt from '../../../assets/img/benefit/oneBt.png';
import twoBt from '../../../assets/img/benefit/twoBt.png';
import threeBt from '../../../assets/img/benefit/threeBt.png';
import fourBt from '../../../assets/img/benefit/fourBt.png';
import fiveBt from '../../../assets/img/benefit/fiveBt.png';
import sixBt from '../../../assets/img/benefit/sixBt.png';
import { AnimatedText } from '../../../assets/component/initComponent';
import AppleCarousel from '../../../assets/component/Slider';
import useInView from '../../../hooks/useInView';

const Benefits = ({ navTrigger }) => {

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); 

	const content = [
		{
			title: 'Financial Planning',
			description: 'Easy-to-use calculators provide instant results, helping users plan investments, loans, and savings with confidence.',
			bg: '#F8FEFF',
			topImg: 'oneTop',
			btImg: oneBt,
			btSize: '65px',
			topSize: '50px',
			color: '156, 234, 252'
		},
		{
			title: 'Quick & Accurate',
			description: 'Real-time calculations deliver clear values, reports, and charts for better financial understanding.',
			bg: '#FFF6F6',
			topImg: 'twoTop',
			btImg: twoBt,
			btSize: '80px',
			topSize: '60px',
			color: '245, 100, 131'
		},
		{
			title: 'Clear Insights',
			description: 'Well-structured results and reports make complex financial data easy to understand.',
			bg: '#FFF1E4',
			topImg: 'threeTop',
			btImg: threeBt,
			btSize: '70px',
			topSize: '50px',
			color: '255, 138, 29'
		},
		{
			title: 'Time-Saving',
			description: 'Quick inputs deliver accurate results instantly, reducing manual effort and calculation errors.',
			bg: '#EFFFFB',
			topImg: 'fourTop',
			btImg: fourBt,
			btSize: '90px',
			topSize: '60px',
			color: '23, 240, 184'
		},
		{
			title: 'Smart Comparisons',
			description: 'Tweak your variables and see the results update instantly. Compare different scenarios (side-by-side?) to find your best path forward.',
			bg: '#F7F0FF',
			topImg: 'fiveTop',
			btImg: fiveBt,
			btSize: '105px',
			topSize: '60px',
			color: '129, 64, 250'
		},
		{
			title: 'Comprehensive Suite',
			description: 'Everything you need in one place. Access a complete range of financial tools so you never have to switch between different apps or websites again.',
			bg: '#FFF6F2',
			topImg: 'sixTop',
			btImg: sixBt,
			btSize: '60px',
			topSize: '60px',
			color: '226, 44, 1'
		}
		// {
		// 	title: 'Financial Planning',
		// 	description: 'Easy-to-use calculators provide instant results, helping users plan investments, loans, and savings with confidence.',
		// 	bg: '#F8FEFF',
		// 	topImg: 'oneTop',
		// 	btImg: oneBt,
		// 	btSize: '65px',
		// 	topSize: '50px',
		// 	color: '156, 234, 252'
		// },
		// {
		// 	title: 'Quick & Accurate',
		// 	description: 'Real-time calculations deliver clear values, reports, and charts for better financial understanding.',
		// 	bg: '#FFF6F6',
		// 	topImg: 'twoTop',
		// 	btImg: twoBt,
		// 	btSize: '80px',
		// 	topSize: '60px',
		// 	color: '245, 100, 131'
		// },
		// {
		// 	title: 'Clear Insights',
		// 	description: 'Well-structured results and reports make complex financial data easy to understand.',
		// 	bg: '#FFF1E4',
		// 	topImg: 'threeTop',
		// 	btImg: threeBt,
		// 	btSize: '70px',
		// 	topSize: '50px',
		// 	color: '255, 138, 29'
		// },
		// {
		// 	title: 'Time-Saving',
		// 	description: 'Quick inputs deliver accurate results instantly, reducing manual effort and calculation errors.',
		// 	bg: '#EFFFFB',
		// 	topImg: 'fourTop',
		// 	btImg: fourBt,
		// 	btSize: '90px',
		// 	topSize: '60px',
		// 	color: '23, 240, 184'
		// }
	];

	const containerRef = useRef(null);
	const [offset, setOffset] = useState(0);

	//InView Hook
	const [sectionRef, inView] = useInView();
	const controls = useAnimation();

	//State
	const [showOnce, setShowOnce] = useState(false);
	const [isViewed, setInsViewed] = useState(false);

	//Ref
	const prevRef = useRef(null);
	const nextRef = useRef(null);
	const sliderRef = useRef(null);
	const hasAnimatedOnScroll = useRef(false);

	//Effect
	useEffect(() => { //Get Count is in view
		if (inView) {
			if (!isViewed) {
				setTimeout(() => {
					setShowOnce(true);
				}, 1500);
				if (!isMobile) {
					setTimeout(() => {
						setShowOnce(false);
						setInsViewed(true);
					}, 2500);
				}
			}
		} else {
			setShowOnce(false);
		}
	}, [inView, isMobile, isViewed]);

	// useEffect(() => {
	// 	if (navTrigger) {
	// 		setTimeout(() => {
	// 			setShowOnce(true);
	// 		}, 1500); 
	// 		setTimeout(() => {
	// 			setShowOnce(false);
	// 		}, 2500); 
	// 	}
	// }, [navTrigger]);

	useEffect(() => {
		const update = () => {
			if (!containerRef.current) return;
			const rect = containerRef.current.getBoundingClientRect();
			setOffset(rect.left);
		};

		update();
		window.addEventListener('resize', update);
		return () => window.removeEventListener('resize', update);
	}, []);
	
	const textVariant = {
		hidden: {
			opacity: 0,
			y: 40
		},
		visible: {
			opacity: 1,
			y: 0,
			scale: 1,
			transition: {
				delay: 0.3,
				duration: 1,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	// //Trigger Animation for Nav Click
	// useEffect(() => {
	// 	if (navTrigger) {
	// 		console.log('inside effect 1');
	// 		controls.start('hidden').then(() => {
	// 			controls.start('visible');
	// 			console.log('inside effect 1.1');
	// 		});
	// 	}
	// }, [navTrigger, controls]);

	// console.log('navTrigger', navTrigger);

	useEffect(() => {
		let isActive = true;

		const replay = async () => {
			if (!navTrigger) return;

			await controls.start('hidden');
			if (!isActive) return;

			await controls.start('visible');
			if (!isActive) return;
		};

		replay();

		return () => {
			isActive = false;
		};
	}, [navTrigger, controls]);

	useEffect(() => {
		if (inView && !hasAnimatedOnScroll.current) {
			controls.start('visible');
			hasAnimatedOnScroll.current = true; // lock it
		}
	}, [inView, controls]);

	return(
		<Box ref={sectionRef} mb={'-32px'}>
			<Container className='containerFull' ref={containerRef}>
				<Grid container spacing={4}>
					<Grid size={12}>
						<Box className='titleWithBg mb10' sx={{ backgroundPosition: 'left' }}>
							<Typography variant='h2' className='font25'>Benefits of App</Typography>
						</Box>
						<AnimatedText
							title={'Building a Lively Community: <br/>Explore Our Benefits'}
							className='font40 fontBolder textCl'
							animate={controls}
						/>
						<Stack direction='row' justifyContent='space-between' alignItems='flex-end' my={3}>
							<Grid size={9}>
								<motion.div
									key={navTrigger}
									variants={textVariant}
									initial='hidden'
									animate={controls}
								>
									<Typography className='font16 textCl'>
										Artha is built on a simple belief that powerful financial tools should be accessible to everyone. Designed for both new investors and experienced planners, it brings powerful financial tools into one place.
									</Typography>
								</motion.div>
							</Grid>
							<Stack direction='row' spacing={1} alignItems='center' mr={3}>
								<IconButton onClick={() => sliderRef.current?.slickPrev()} sx={{  }}>
									<ArrowOutwardIcon ref={prevRef} className='font40' style={{ transform: 'rotate(180deg)', color: '#676767', cursor: 'pointer' }}/>
								</IconButton>
								<IconButton onClick={() => sliderRef.current?.slickNext()}>
									<ArrowOutwardIcon ref={nextRef} className='font40' style={{ color: '#676767', cursor: 'pointer' }}/>
								</IconButton>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</Container>
			<Box>
				<AppleCarousel offset={offset} prevRef={prevRef} nextRef={nextRef} content={content} showOnce={showOnce} animate={controls}/>
			</Box>
		</Box>
	);
};

export default Benefits;
